import React, { Component } from 'react';
import { Modal, Row, Col, Button } from 'react-bootstrap';
import {SessionStore} from '../../../stores';
import {ConferenceActions, AccountActions, AlertActions} from '../../../actions';
import {Joi, Validation} from 'react-validation-decorator';
import Confirmation from "../Confirmation";

class VerifyEmailAfterConf extends Component{
  constructor(props) {
    super(props);
    this.state ={
      openVerifyEmail:true,
      agreeToPolicy : false,
      showThanksPopup : true,      
      showVerifyEmailPopup : false,
      showEmailChangePopup: false,
      showOtpPopup : false,
      otp : null,
      newEmail : null,
      fShowPendingUserMessage : false,
      fAlreadyExistsMessage : false,
      fShowOtpBox : false,
      fShowMergedProfMessage : false
    };
    this._handleOnSubmit = this._handleOnSubmit.bind(this);
  };
  validationSchema = Joi.object().keys({
    newEmail: Joi.string().email().lowercase().required().label('Email'),
    agreeToPolicy: Joi.boolean().required().invalid(false)
  });
  componentWillUpdate(nextprops, nextstate){
    if(this.state.openVerifyEmail != nextstate.openVerifyEmail){
      this.props.closeModal();
    }
  }
  render() {
    const SessionUser = SessionStore.getSessionUser();
    let {openVerifyEmail,email, agreeToPolicy, showThanksPopup, showVerifyEmailPopup,fAlreadyExistsMessage,
       showEmailChangePopup, showOtpPopup, fShowPendingUserMessage, fShowMergedProfMessage, otp, newEmail} = this.state;
       console.log("fAlreadyExistsMessage===========",fAlreadyExistsMessage);
    return(
      <Modal show={openVerifyEmail} >
        <Modal.Body className="pa0">
            <div className="info-box-large round-corner clearfix h-100p">
            <div className="titleBox">
              <h4 className="title m0 py5">Verify Email</h4>
            </div>
            <div className="col-sm-12 mt20 mb20">
            {
              showThanksPopup &&
              <form name="thanksForm" noValidate>
                <p>Thank you for sharing your experience! Please verify that your email is <strong>{SessionUser.email}</strong></p>
                <Row>
                  <Col xs={12} className="pull-right">

                    <div className="checkbox">
                      <label style={{fontWeight: 'normal'}}>
                        <input type="checkbox" checked= {agreeToPolicy}
                              //  value={agreeToPolicy}
                              onChange={this._handleInputChange.bind(this, 'agreeToPolicy')} />
                        I agree to the
                        <a href="https://mentorstudents.org/terms-and-conditions" target="_blank">
                          <span> Terms of Use </span>
                        </a> and
                        <a href="https://mentorstudents.org/privacy-policy" target="_blank">
                          <span> Privacy Policy </span>
                        </a>
                      </label>
                    </div>
                  </Col>
                </Row>  

                <Row>
                  <Col md={12}>
                  <div className="mt5">
                      <Button type="submit"
                              bsStyle="success"
                              value="submit"
                              disabled={ this.state.agreeToPolicy == false ? true : false}
                              onClick={(e)=>{this._handleSubmit(e,'thanksSubmit')}}>
                        Submit
                      </Button>&nbsp;
                      <Button type="submit"
                              bsStyle='danger'
                              value="cancel"
                              onClick={(e)=>{this._handleSubmit(e,'thanksSubmit')}}>
                        Cancel
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            }
            {
              showVerifyEmailPopup &&
              <form name="emailWithOTPFrm" noValidate>
                <Row>
                  <Col md={12}>
                    <div>
                          We can send you a monthly report of the impact your interview makes. Please provide an email that may not change when you change your job/school. Would your email address <strong>{SessionUser.email}</strong> continue to work when you change your job or school?
                    </div>
                  </Col>
                </Row>           
                <Row>
                  <Col md={12}>
                  <div className="mt5">
                      <Button type="submit"
                              bsStyle="success"
                              value="yes"
                              // disabled={ this.state.agreeToPolicy == false ? true : !!this.state.validation.errors.length}
                              onClick={(e)=>{this._handleSubmit(e,'emailVerifySubmit')}}>
                        Yes
                      </Button>&nbsp;
                      <Button type="submit" value="no"
                              bsStyle='danger'
                              onClick={(e)=>{this._handleSubmit(e,'emailVerifySubmit')}}>
                        No
                      </Button>
                    </div>

                  </Col>
                </Row>
              </form>
            }
            {
              showEmailChangePopup &&
              <form name="emailWithOTPFrm" noValidate>
                <Row>
                  <Col md={12}>
                    <div>
                      Please provide an email that will not change when you change your job/school.
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className={this.getValidationClassName('newEmail')}>
                      <input 
                            type='email' className='form-control mt20 mb20'
                            value={newEmail || ""}
                            placeholder="Enter Email..."
                            onChange={this._handleInputChange.bind(this, 'newEmail')}
                      />
                      {this.renderValidationMessages('newEmail')}
                    </div>
                  </Col>
                </Row>           
                <Row>
                  <Col md={12}>
                  <div className="mt5">
                      <Button type="submit"
                              bsStyle="success"
                              disabled={ this.state.agreeToPolicy == false ? true : !!this.state.validation.errors.length}
                              onClick={(e)=>{this._handleSubmit(e,'emailChangedSubmit')}}>
                        Submit
                      </Button>
                  </div>
                  </Col>
                </Row>
              </form>
            }
            {
              fShowPendingUserMessage &&
              <div>
                  <Confirmation onClose={()=>{}} okLabel='ok' showCancelButton={false} open={fShowPendingUserMessage}
                                message= { `Please click the link sent to ${newEmail} from support@mentorstudents.org. After that, follow the instructions given in the link to merge profiles for this account and for the account with email ${newEmail}`}
                                title={'Merge Profile'}
                                _handleSubmit={() => {this.setState({openVerifyEmail : false})} }
                  />                
                
              </div>
            }
            {
              fShowMergedProfMessage &&
              <div>
                  <Confirmation onClose={()=>{}} okLabel='ok' showCancelButton={false} open={fShowMergedProfMessage}
                                message= { `Follow the instructions given in the link to merge profiles for this account and for the account with email ${newEmail}`}
                                title={'Merge Profile'}
                                _handleSubmit={() => {this.setState({openVerifyEmail : false})} }
                  />                
                
              </div>
            }
            {
              fAlreadyExistsMessage &&
              <div>
                  <Confirmation onClose={()=>{}} okLabel='ok' showCancelButton={false} open={fAlreadyExistsMessage}
                                message= { `This email already exists in your account`}
                                title={'Already Exists'}
                                _handleSubmit={() => {this.setState({openVerifyEmail : false})} }
                  />                
                
              </div>
            }
            {/* {
              fShowMergedProfMessage && 
              <div>
                Follow the instructions given in the link to merge profiles for this account and for the account with email {newEmail}
              </div>
            } */}
            {
              showOtpPopup &&
              <form name="emailWithOTPFrm" noValidate>
              <Row>
                <Col md={12}>
                  <div className={this.getValidationClassName('email')}>
                    <label>Email</label>
                    <input
                           type='email' className='form-control'
                           value={newEmail || ""}
                           readOnly={true}
                           placeholder="Enter Email..."
                           onChange={this._handleInputChange.bind(this, 'email')}
                    />
                  </div>
                    {this.renderValidationMessages('email')}
                </Col>
              </Row>
  
              <Row>
                <Col md={12}>
                  <div className={this.getValidationClassName('otp')}>
                    <label>Verify 4 digit number sent to your email {email}</label>
                    <input  type='text' className='form-control'
                           value={otp || ""}
                           placeholder="Enter OTP..."
                           onChange={this._handleInputChange.bind(this, 'otp')}/>
                    {this.renderValidationMessages('otp')}
                  </div>
                </Col>
              </Row>
  
              <Row>
                <Col xs={12} className="pull-right">  
                  <div className="mt5">
                    <Button type="submit"
                            bsStyle="success"
                            disabled={ !(agreeToPolicy && newEmail && otp && otp.length == 4)}
                            onClick={(e)=>{this._handleSubmit(e,'submitOtp')}}>
                      Submit
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>  
            }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  };
  _handleInputChange(formInput, event) {
    let {value} = event.target;
    if (formInput === 'agreeToPolicy') {
      value = !this.state['agreeToPolicy'];
    }
    this.setState(state => {
      state[formInput] = value;
    }, () => {
      this.validate(formInput);
    });
  };
  _handleSubmit(e,type){
    e.preventDefault();
    if(type == 'thanksSubmit'){
      if(e.target.value == 'submit'){
        this.setState({showThanksPopup : false, showVerifyEmailPopup : true})
      }
      else{
        this.setState({openVerifyEmail:false,showThanksPopup : false, showVerifyEmailPopup : false, showEmailChangePopup : false, showOtpPopup : false});
      }
    }
    else if(type == 'emailVerifySubmit'){
      if(e.target.value == 'no'){
        this.setState({showThanksPopup : false, showVerifyEmailPopup : false, showEmailChangePopup : true});
      }
      else{
        this.setState({openVerifyEmail:false,showThanksPopup : false, showVerifyEmailPopup : false, showEmailChangePopup : false, showOtpPopup : false});
      }
    }
    else if(type == 'emailChangedSubmit'){
      this.setState({showThanksPopup : false, showVerifyEmailPopup : false, showEmailChangePopup : false})
      this._handleOnSubmit(this.state.newEmail, this.state.agreeToPolicy);
    }
    else if(type == 'submitOtp'){
      this._handleOnSubmit(this.state.newEmail, this.state.agreeToPolicy,this.state.otp);
    }
  }
  changeAgreeToPolicy = (value)=>{
    this.setState({agreeToPolicy : value});
  }
  _handleOnSubmit(email, agreeToPolicy, otp){
    const {conference, mentor} = this.props;
    if(otp){
      otp = parseInt(otp);
      ConferenceActions.verifyEmailWithOTP({email, otp},(err)=>{
        if(!err){
          this.setState({openVerifyEmail:false});
          AlertActions.success({ message: "Email Updated Successfully." });
        }
        // if(err){
        //   this.setState({emailPopupError:true,emailPopupErrorMessage:err.message});
        // }else{
        //   this.setState({openVerifyEmail:false,emailPopupError:false,emailPopupErrorMessage:''});
        // }
      })
    } else {
      AccountActions.makeRequestToAddEmail({email}, (err, response)=>{
        console.log("response============",response);
        if(!err){
          if(response.pendingUserExists){
            this.setState({fShowPendingUserMessage : true, newEmail : email});
          }
          else if(response.showMergedProf){
            this.setState({fShowMergedProfMessage : true, newEmail: email});
          }
          else if(response.alreadyExists){
            this.setState({fAlreadyExistsMessage : true, newEmail: email});
          }
          else if(response.showOtp){
            this.setState({showOtpPopup : true, newEmail: email});
          }
        }
        // else if(err){
        //   this.setState({noEmailPopupError:true,noEmailPopupErrorMessage:err.message});
        // }
      })
    }
  }
}
export default Validation(VerifyEmailAfterConf);
